<app-header-latest></app-header-latest>
<section class="terms-popup">

    <div class="popup-container">
      <div class="popup-card"></div>

        <h2 class="title">PRICING POLICY</h2>

        <p><strong>Last Updated:</strong> 30-June-2026</p>

        <h2>1. INTRODUCTION</h2>

        <p>
            This Pricing Policy outlines the terms and conditions for the pricing of services offered on
            NeoHRMZ Website <strong>("Application").</strong>This policy is designed to provide transparency regarding
            the fees and charges associated with using the NeoHRMZ services, including but not limited to
            employee management, employee training, employee counselling, employee benefits,
            advertisements, and subscription plans. Employers, agencies, vendors, and users are requested
            to choose the appropriate pricing plan for effective business results.
        </p>

        <h2>2. PRICING STRUCTURE</h2>

        <h3>2.1. NeoHRMZ Fees</h3>

        <p>
            There are different HRMS packages for different needs of employers, agencies, vendors, and
            users across various business sectors. Pricing starts with an economical plan and increases
            with enhanced benefits.
        </p>

        <h3>2.2. Subscription Plans</h3>

        <p>
            Subscription Plans are available on Monthly, Bi-Monthly, Quarterly, Half-Yearly, Yearly,
            or as applicable for employers, agencies, vendors, and users across India. Plans begin with
            an economical package and increase according to the benefits offered.
        </p>

        <h2>3. PAYMENT TERMS</h2>

        <p><strong>3.1. Payment Methods:</strong> Payments can be made via Credit Card, Debit Card,
            Net Banking, UPI, or any other payment methods accepted by the NeoHRMZ Application.</p>

        <p><strong>3.2. Billing Cycle:</strong> Payments for HRMS services are due upfront at the time
            of purchase. Subscription plans will be billed according to the selected billing cycle
            (Monthly, Bi-Monthly, Quarterly, Half-Yearly, Yearly, or as applicable).</p>

        <p><strong>3.3. Taxes:</strong> All prices are exclusive of applicable taxes, which will be
            added at checkout according to prevailing tax laws.</p>

        <p><strong>3.4. Invoices:</strong> A digital invoice will be provided for every transaction
            and sent to the registered email address. It will also be available in the user's account dashboard.</p>

        <p><strong>3.5.</strong> Subscriptions renew automatically unless cancelled at least 24 hours
            before the end of the current billing cycle.</p>

        <p>Payment details are managed in <strong>Settings &gt; Subscriptions</strong> on your device.</p>

        <h2>4. CHANGES TO PRICING</h2>

        <p>
            NeoHRMZ reserves the right to change the pricing of its services at any time.
            Users will be notified of any pricing changes at least 30 days in advance.
            Price changes will not affect any ongoing subscriptions or services purchased
            before the effective date of the pricing change.
        </p>

        <h2>5. DISCOUNTS AND PROMOTIONS</h2>

        <p>
            <strong>5.1. Promotions:</strong>
            From time to time, NeoHRMZ may offer promotions, discounts, or special pricing
            on selected services. These offers are subject to the applicable terms and conditions.
        </p>

        <p>
            <strong>5.2. Bulk Discounts:</strong>
            Discounts on HRMS services may be available for bulk purchases or large-volume users.
            Please contact NeoHRMZ for more information.
        </p>

        <h2>6. REFUND POLICY</h2>

        <p>
            <strong>6.1. HRMS Services:</strong>
            No refunds will be issued once the user has been granted access to the NeoHRMZ Portal.
        </p>

        <p>
            <strong>6.2. Subscription Plans:</strong>
            Refund requests for subscription plans will be considered on a case-by-case basis.
            Pro-rated refunds may be offered if the service is cancelled before the end of the subscription period.
        </p>

        <p>
            <strong>6.3. Advertising, Promotions and Sponsorships:</strong>
            Refunds for advertising services are not permitted once advertisements have been displayed
            or promotional campaigns have commenced.
        </p>

        <h2>7. CANCELLATION POLICY</h2>

        <p>
            <strong>7.1. Subscription Services:</strong>
            Users may cancel their subscription at any time through their account settings.
            Cancellation becomes effective at the end of the current billing cycle.
        </p>

        <p>
            <strong>7.2. One-Time Purchases:</strong>
            One-time purchases cannot be cancelled once the transaction has been completed.
        </p>

        <h2>8. ACCEPTANCE OF POLICY</h2>

        <p>
            By using the services offered by NeoHRMZ, users agree to the terms and conditions
            outlined in this Pricing Policy. If you do not agree with any part of this policy,
            please refrain from using the services.
        </p>

        <h2>9. CONTACT INFORMATION</h2>

        <p>
            For any questions or concerns regarding this Pricing Policy, please contact our support team:
        </p>

        <p>
            <strong>Email:</strong>
            <a href="mailto:contact&#64;neohrmz.com">contact&#64;neohrmz.com</a>
        </p>

        <p>
            <strong>Phone:</strong> +91-984 984 8195
        </p>

    </div>
</section>
 <app-peopleflow-footer></app-peopleflow-footer>
